<template>
  <div class="auth-callback">
    <div class="loading-container">
      <div class="spinner"></div>
      <p>認証処理中...</p>
    </div>
  </div>
</template>

<script>
import { onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useAuthStore } from "@/store/authStore";
import { commitSessionToken } from "@/api/session-context.js";
import { invalidateShioriDestinationImageWorkflows } from "@/utils/ensure-shiori-destination-image.js";

export default {
  name: "AuthCallback",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const authStore = useAuthStore();

    onMounted(async () => {
      try {
        const token = route.query.token;
        const error = route.query.error;

        if (error) {
          // エラーがある場合はログインページへ
          console.error("Google auth error:", error);
          alert("Google認証に失敗しました。もう一度お試しください。");
          router.push("/login");
          return;
        }

        if (token) {
          // トークンをローカルストレージに保存
          invalidateShioriDestinationImageWorkflows();
          commitSessionToken(token);
          authStore.token = token;

          // ユーザー情報を取得
          await authStore.fetchUser();

          // マイページへリダイレクト
          router.push("/mypage");
        } else {
          // トークンがない場合はログインページへ
          router.push("/login");
        }
      } catch (error) {
        console.error("Auth callback error:", error);
        alert("認証処理中にエラーが発生しました。");
        router.push("/login");
      }
    });

    return {};
  },
};
</script>

<style scoped>
.auth-callback {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #B4CF9E 0%, #C5DCB3 100%);
}

.loading-container {
  text-align: center;
  color: white;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-container p {
  font-size: 1.125rem;
  font-weight: 500;
}
</style>
